import type { ReactNode } from "react";
import { SiteNav } from "@/components/site/SiteNav";
import { SiteFooter } from "@/components/site/SiteFooter";

export function PageShell({
  eyebrow,
  title,
  lede,
  children,
}: {
  eyebrow?: string;
  title: string;
  lede?: string;
  children?: ReactNode;
}) {
  return (
    <>
      <SiteNav />
      <main className="min-h-screen bg-background text-ink pt-[calc(var(--nav-h)+4rem)] md:pt-[calc(var(--nav-h)+5rem)] pb-24">
        <div className="mx-auto max-w-7xl px-6 md:px-8">
          {eyebrow && (
            <div className="text-xs uppercase tracking-[0.25em] text-ink/50 mb-5">{eyebrow}</div>
          )}
          <h1 className="font-display text-5xl md:text-7xl leading-[1.02] text-balance max-w-4xl">
            {title}
          </h1>
          {lede && (
            <p className="mt-6 text-lg md:text-xl text-ink/70 max-w-2xl leading-relaxed">{lede}</p>
          )}
          <div className="mt-14">{children}</div>
        </div>
      </main>
      <SiteFooter />
    </>
  );
}
